import {
  DefyMedicalBenefitsSection,
  HomeFeatureCardSection,
  ImageCtaCardSection,
  HomeHowItWorksSection,
  ImageWithTextSection,
  FAQSection,
} from "@/design-system/Organisms";
import { homeFaqDataConfig } from "@/design-system/Organisms/FAQSection/faq.config";
import { homeImageCtaCardConfig } from "@/design-system/Organisms/ImageCtaCardSection/imageCtaCard.config";
import { homeImageWithTextConfig } from "@/design-system/Organisms/ImageWithTextSection/imageWithText.config";
import { homeHowItWorksConfig } from "@/design-system/Organisms/HomeHowItWorksSection/homeHowItWorks.config";

const HomePageTemplate = () => {

  return (
    <>
      <HomeFeatureCardSection />
      <HomeHowItWorksSection {...homeHowItWorksConfig} />
      <DefyMedicalBenefitsSection />
      <ImageWithTextSection  {...homeImageWithTextConfig} />
      <FAQSection {...homeFaqDataConfig} />
      <ImageCtaCardSection {...homeImageCtaCardConfig} />
    </>
  );
};

export default HomePageTemplate;
